// <head> metadata for HomePage (https://www.dbos.dev/).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'DBOS | Durable Workflow Orchestration',
    },
    {
      name: 'description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that simplifies building and operating reliable, observable workflows.',
    },
    {
      property: 'og:title',
      content: 'DBOS | Durable Workflow Orchestration',
    },
    {
      property: 'og:description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that simplifies building and operating reliable, observable workflows.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      name: 'twitter:title',
      content: 'DBOS | Durable Workflow Orchestration',
    },
    {
      name: 'twitter:description',
      content:
        'DBOS is an open source durable execution and workflow orchestration system that simplifies building and operating reliable, observable workflows.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/dbos-og-durable-workflows-postgres.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev',
      rel: 'canonical',
    },
  ],
  scripts: [
    {
      // Who DBOS is, for search engines' company panels and AI answers.
      type: 'application/ld+json',
      children: JSON.stringify(
        {
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Organization',
              '@id': 'https://www.dbos.dev/#organization',
              name: 'DBOS',
              legalName: 'DBOS, Inc.',
              url: 'https://www.dbos.dev/',
              logo: {
                '@type': 'ImageObject',
                url: 'https://www.dbos.dev/assets/images/67346bd73374d61e8a40f563_dbos-256.png',
                width: 256,
                height: 256,
              },
              description:
                'DBOS is an open source durable execution and workflow orchestration system that simplifies building and operating reliable, observable workflows.',
              sameAs: [
                'https://github.com/dbos-inc',
                'https://www.linkedin.com/company/dbos-inc/',
                'https://twitter.com/DBOS_Inc',
                'https://www.youtube.com/@DBOS-Inc',
              ],
              contactPoint: { '@type': 'ContactPoint', contactType: 'sales', url: 'https://www.dbos.dev/contact' },
            },
            {
              '@type': 'WebSite',
              '@id': 'https://www.dbos.dev/#website',
              name: 'DBOS',
              url: 'https://www.dbos.dev/',
              inLanguage: 'en',
              publisher: { '@id': 'https://www.dbos.dev/#organization' },
            },
          ],
        },
        null,
        2,
      ),
    },
  ],
};
